import React from "react";
import styled from "styled-components";
import { Negative, Positive } from "./styles/formatting";

const HeaderWrapper = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const TitleWrapper = styled.h1`
  align-items: center;
  display: flex;
  font-size: 10vh;
  height: 76px;
`;

const Header = () => (
  <HeaderWrapper>
    <TitleWrapper>
      <Positive>H</Positive>
      <Negative>E</Negative>
      <Positive>G</Positive>
      <Negative>E</Negative>
      <Positive>L</Positive>
    </TitleWrapper>
  </HeaderWrapper>
);

export default Header;
